export default {
    state: {
        all: [],
        filtered: [],
        selectedLease: []
    },
};